<template>
  <section>
    <div class="tachyon-container why-tachyon-section">
      <h2>Why Tachyon?</h2>
      <div class="why-tachyon-icons">
        <div>
          <div>
            <v-lazy-image src="/static/img/features_page/why_tachyon_icons/GDPR.svg" src-placeholder="/static/img/placeholder.jpg" alt="GDPR"/>
            <div>Fully GDPR Compliant (Value)</div>
          </div>
        </div>
        <div>
          <div>
            <v-lazy-image src="/static/img/features_page/why_tachyon_icons/implementation.svg" src-placeholder="/static/img/placeholder.jpg" alt="implementation"/>
            <div>Implement Single Customer View in Weeks</div>
          </div>
        </div>
        <div>
          <div>
            <v-lazy-image src="/static/img/features_page/why_tachyon_icons/analytics.svg" src-placeholder="/static/img/placeholder.jpg" alt="analytics"/>
            <div>Real-time Decisioning and Analytics</div>
          </div>
        </div>
        <div>
          <div>
            <v-lazy-image src="/static/img/features_page/why_tachyon_icons/democratization.svg" src-placeholder="/static/img/placeholder.jpg" alt="democratization"/>
            <div>Democratization of Data</div>
          </div>
        </div>
        <div>
          <div>
            <v-lazy-image src="/static/img/features_page/why_tachyon_icons/time.svg" src-placeholder="/static/img/placeholder.jpg" alt="time"/>
            <div>Minimal Development Time for ETL Processes and Tasks</div>
          </div>
        </div>
        <div>
          <div>
            <v-lazy-image src="/static/img/features_page/why_tachyon_icons/fingerprint.svg" src-placeholder="/static/img/placeholder.jpg" alt="fingerprint"/>
            <div>Customer Fingerprinting Out of The Box</div>
          </div>
        </div>
        <div>
          <div>
            <v-lazy-image src="/static/img/features_page/why_tachyon_icons/truth.svg" src-placeholder="/static/img/placeholder.jpg" alt="truth"/>
            <div>Single Source of Truth</div>
          </div>
        </div>
        <div>
          <div>
            <v-lazy-image src="/static/img/features_page/why_tachyon_icons/internet-grid.svg" src-placeholder="/static/img/placeholder.jpg" alt="internet grid"/>
            <div>Integrate With Web, IoT and Any Device With access to The Internet</div>
          </div>
        </div>
      </div>
    </div>
    <div class="tachyon-container">
      <div class="blue-section">
        <div class="top-block">
          <div>
            <v-lazy-image src="/static/img/features_page/nutshell.png" src-placeholder="/static/img/placeholder.jpg" alt="nutshell"/>
            <h2>Tachyon in a<br>Nutshell</h2>
            <p>Your path through a digital transformation doesn’t have to be complex, long and costly one.</p>
            <p><strong>Tachyon is a simple, highly scalable, ultra performant big data collection, consolidation and democratisation platform.</strong></p>
            <p>To harness the power of big data, you would require an infrastructure that can manage and process huge volumes of structured and unstructured data in realtime and can protect data privacy and security.</p>
          </div>
          <v-lazy-image class="nutshell-img" src="/static/img/features_page/big_data_visualization.svg" src-placeholder="/static/img/placeholder.jpg" alt="big data visualization"/>
        </div>
        <div class="separation-line1"></div>
        <div class="middle-block">
          <v-lazy-image src="/static/img/features_page/warehouse.svg" src-placeholder="/static/img/placeholder.jpg" alt="warehouse"/>
          <div class="text">
            <h2>Tachyon is a friend of BI Developers, Analysts and Data Scientists</h2>
            <p>This include systems like MongoDB that provide operational capabilities for real-time, interactive workloads where data is primarily captured and stored.</p>
            <p><strong>NoSQL Big Data</strong> systems are designed to take advantage of new cloud computing architectures that have emerged over the past decade to allow massive computations to be run inexpensively and efficiently. This makes operational big data workloads much easier to manage, cheaper, and faster to implement.</p>
            <p>Some NoSQL systems can provide insights into patterns and trends based on real-time data with minimal coding and without the need for data scientists and additional infrastructure.</p>
          </div>
        </div>
        <div class="separation-line2"></div>
        <div class="bottom-block">
          <v-lazy-image src="/static/img/features_page/crm.svg" src-placeholder="/static/img/placeholder.jpg" alt="crm"/>
          <h2>Activation Systems Integrations such as Marketing Automation and CRM</h2>
          <div>
            <p>These includes systems like Massively Parallel Processing (MPP) database systems and <span class="blue-text">MapReduce</span> that provide analytical capabilities for retrospective and complex analysis that may touch most or all of the data.</p>
            <p>These two classes of technology are complementary and frequently deployed together.</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'WhyTachyon'
  }
</script>

<style scoped>
  .why-tachyon-section {
    font-family: 'RubicMedium', sans-serif;
    font-weight: 500;
  }
  .why-tachyon-section h2 {
    font-size: 62px;
    line-height: 73px;
    color: #686b84;
    text-align: center;
  }
  .why-tachyon-icons {
    display: flex;
    flex-wrap: wrap;
  }
  .why-tachyon-icons > div {
    flex: 1 0 25%;
  }
  .why-tachyon-icons > div > div {
    width: 100%;
    max-width: 230px;
    margin: 60px auto 0;
    padding-right: 10px;
    padding-left: 10px;
  }
  .why-tachyon-section div {
    color: #000;
    font-size: 15px;
    line-height: 18px;
    text-align: center;
  }
  .blue-section {
    position: relative;
    padding: 70px 80px;
    margin-top: 100px;
    background-color: #131737;
    z-index: 1;
  }
  .top-block,
  .middle-block,
  .bottom-block {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }
  .bottom-block {
    align-items: center;
  }
  .top-block h2 {
    font-family: 'RubicMedium', sans-serif;
    font-weight: 500;
    font-size: 42px;
    line-height: 50px;
    padding-top: 25px;
    padding-bottom: 30px;
  }
  .top-block p {
    width: 312px;
    color: #cbcee9;
    text-align: justify;
  }
  .nutshell-img {
    margin-right: -200px;
    margin-left: 50px;
  }
  .separation-line1 {
    width: 310px;
    height: 4px;
    background: #5855d5;
  }
  .middle-block {
    padding-top: 80px;
  }
  .middle-block h2 {
    font-family: 'RubicMedium', sans-serif;
    font-weight: 500;
    font-size: 52px;
    line-height: 62px;
    padding-top: 40px;
    padding-bottom: 30px;
  }
  .middle-block .text {
    width: 100%;
    max-width: 639px;
    margin-left: 50px;
  }
  .separation-line2 {
    width: 100%;
    height: 4px;
    background: #5855d5;
    margin: 80px 0;
  }
  .bottom-block h2 {
    font-family: 'RubicMedium', sans-serif;
    font-weight: 500;
    font-size: 42px;
    line-height: 50px;
    width: 360px;
    margin: 0 15px;
  }
  .bottom-block p {
    width: 367px;
  }
  @media (max-width: 1199px) {
    .blue-section {
      padding-left: 50px;
      padding-right: 50px;
    }
    .nutshell-img {
      margin-top: -150px;
    }
    .separation-line1 {
      margin-top: 50px;
    }
  }
  @media (max-width: 991px) {
    .why-tachyon-section h2 {
      padding-top: 50px;
    }
    .why-tachyon-section > div {
      width: 100%;
      max-width: 730px;
      margin: 0 auto;
    }
    .blue-section {
      width: 100%;
      max-width: 730px;
      margin-right: auto;
      margin-left: auto;
      padding-left: 30px;
      padding-right: 30px;
    }
    .nutshell-img {
      position: absolute;
      right: 0;
      width: 60%;
      margin-right: -100px;
    }
    .middle-block {
      padding-top: 10px;
    }
    .middle-block img {
      position: absolute;
      top: 7%;
      right: 0;
      width: 40%;
    }
    .middle-block h2 {
      width: 60%;
    }
    .middle-block .text {
      margin-left: 0;
    }
    .top-block p,
    .middle-block p,
    .bottom-block p {
      width: 100%;
      text-align: justify;
    }
    .separation-line2 {
      margin-top: 40px;
      margin-bottom: 50px;
    }
    .bottom-block {
      flex-direction: column;
      align-items: flex-start;
    }
    .bottom-block h2 {
      margin: 0 0 20px;
    }
    .bottom-block img {
      position: absolute;
      right: 0;
    }
    .nutshell-img {
      margin-left: 10px;
    }
  }
  @media (max-width: 767px) {
    .why-tachyon-section h2 {
      padding-bottom: 40px;
    }
    .why-tachyon-icons > div {
      flex: 1 0 50%;
    }
    .why-tachyon-icons > div:nth-child(odd) {
      border-right: 1px solid #eaeaea;
    }
    .why-tachyon-icons > div:not(:nth-child(-n+2)) {
      border-top: 1px solid #eaeaea;
    }
    .why-tachyon-icons > div > div {
      margin-top: 20px;
      margin-bottom: 20px;
    }
    .nutshell-img {
      width: 100%;
      margin-right: -150px;
      max-width: 300px;
      top: 15%;
    }
    .middle-block h2 {
      font-size: 46px;
      line-height: 56px;
    }
    .bottom-block h2 {
      width: 50%;
    }
    .bottom-block img {
      top: 6%;
      width: 37%;
    }
    .nutshell-img {
      margin-left: 0;
    }
  }
  @media (max-width: 575px) {
    .middle-block h2 {
      font-size: 40px;
      line-height: 50px;
    }
  }
  @media (max-width: 479px) {
    .why-tachyon-section h2 {
      font-size: 30px;
      line-height: 36px;
      padding-top: 25px;
      padding-bottom: 25px;
    }
    .why-tachyon-section div {
      font-size: 12px;
      line-height: 14px;
    }
    .blue-section {
      margin-top: 50px;
      padding: 30px 15px;
    }
    .top-block h2 {
      font-size: 30px;
      line-height: 36px;
    }
    .middle-block img {
      max-width: 120px;
    }
    .top-block p,
    .middle-block p,
    .bottom-block p {
      font-size: 14px;
      line-height: 20px;
    }
    .separation-line1 {
      width: 100px;
    }
    .middle-block h2 {
      font-size: 23px;
      line-height: 27px;
    }
    .bottom-block h2 {
      font-size: 25px;
      line-height: 30px;
    }
    .bottom-block img {
      top: 5%;
      width: 40%;
      max-width: 150px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Features/WhyTachyon.vue